import { useState } from 'react';

import InvestigationCharts from '../Investigation/InvestigationComponents/EntityStatistics/InvestigationCharts';
import AuthsPie from '../AuthPie/AuthsPie';
import exportIcon from '../common/Images/export.png';
import styles from './AuthStatistics.module.css';
import { entityAuthenticationOverTimeExport, entityProtocolUsageExport } from '../Investigation/InvestigationUtils';
import useFeature from '../SystemSettings/hooks/featureFlags/useFeature';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';

const AuthStatistics = ({
    className,
    activityByProtocol,
    protocolUsage,
    usageByProtocol,
    totalAuths,
    daysFilter = undefined,
    topLeftSelectComponent = null,
    hidePadding = false
}) => {
    const [isPaiChart, setIsPaiChart] = useState(false);

    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const isSaas = systemMode !== SYSTEM_MODES.ON_PREM;

    const exportStatistics = () => {
        if (isPaiChart) {
            entityProtocolUsageExport(protocolUsage);
        } else {
            entityAuthenticationOverTimeExport(activityByProtocol);
        }
    };

    return (
        <div className={`${styles.warper} ${hidePadding ? styles.noPadding : ''} ${className ?? ''}`}>
            <div className={`${styles.upSide} ${!topLeftSelectComponent && styles.upSideNoTopLeftSelectComponent}`}>
                {topLeftSelectComponent}
                <div>
                    <button
                        className={`${styles.graphButton} ${!isPaiChart ? styles.selected : ''}`}
                        onClick={() => setIsPaiChart(false)}>
                        Authentications Graph
                    </button>
                    <button
                        className={`${styles.graphButton} ${isPaiChart ? styles.selected : ''}`}
                        onClick={() => setIsPaiChart(true)}>
                        Authentication Types
                    </button>
                    <button className={styles.exportButton} onClick={exportStatistics} title="Export">
                        <img src={exportIcon} alt="" />
                    </button>
                </div>
            </div>
            <div className={styles.bottomPane}>
                {!isPaiChart && (
                    <InvestigationCharts
                        activityByProtocol={activityByProtocol}
                        usageByProtocol={usageByProtocol}
                        totalAuths={totalAuths}
                        daysToShow={daysFilter}
                        isSaas={isSaas}
                    />
                )}
                {isPaiChart && <AuthsPie protocolUsages={protocolUsage} large={true} />}
            </div>
        </div>
    );
};
export default AuthStatistics;
